/**
 * Bảng giá của quán — mỗi loại bàn một thẻ dọc.
 *
 * Không còn cột hotline và cũng không còn nút đặt bàn: quán chỉ có một số điện
 * thoại, in lại ở từng dòng là thừa. Bấm vào thẻ là gọi thẳng số đó — cả trang
 * chỉ còn đúng một hành động.
 *
 * Nhiều mức giá theo khung giờ là nhiều dòng riêng do admin nhập; FO không xử
 * lý logic giờ, chỉ hiển thị ghi chú kèm theo.
 */
import React from "react";
import TIcon from "../../components/ui/TIcon";
import { PriceItem } from "../../interfaces/venue";
import { formatPricePerHour, telHref } from "../../helpers/venue";

interface Props {
  items: PriceItem[];
  hotline: string;
}

const PricingSection: React.FC<Props> = ({ items, hotline }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <section className="vn-section" id="bang-gia">
      <h2 className="vn-section-title">Bảng giá</h2>

      <div className="vn-price-list">
        {items.map((item) => (
          <a
            className="vn-price-card"
            key={item.id}
            href={telHref(hotline)}
            aria-label={`${item.tableType} — gọi ${hotline} để đặt bàn`}
          >
            <div className="vn-thumb">
              {item.image ? (
                <img src={item.image} alt="" loading="lazy" aria-hidden />
              ) : (
                <TIcon name="photo" />
              )}
            </div>

            <div className="vn-price-info">
              <div className="vn-price-type">{item.tableType}</div>
              {item.note ? <div className="vn-price-note">{item.note}</div> : null}
              <div className="vn-price-note">{item.quantity} bàn</div>
              <div
                className={`vn-price-value${
                  item.pricePerHour === null ? " muted" : ""
                }`}
              >
                {formatPricePerHour(item.pricePerHour)}
                {item.pricePerHour === null ? "" : " / giờ"}
              </div>
            </div>

            <span className="vn-price-call" aria-hidden>
              <TIcon name="phone" />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default PricingSection;
